import index from './index.common';
export default index;



/** WEBPACK FOOTER **
 ** ../~/jshint-loader!./index.js
 **/